const AUTH_ERROR_STATUSES = [401, 403];

export type StatusMessage = { params?: Record<string, unknown>; translationKey: string } | { text: string };

// An auth failure's body is a transport string, never upload copy, so it falls through to the translatable fallback.
const extractUploadErrorMessage = (error: unknown): string | undefined => {
	if (!error || typeof error !== "object") return undefined;
	const status = (error as { status?: unknown }).status;
	if (typeof status === "number" && AUTH_ERROR_STATUSES.includes(status)) return undefined;
	const data = (error as { data?: unknown }).data;
	if (!data || typeof data !== "object") return undefined;
	const message = (data as { error?: unknown }).error;
	return typeof message === "string" ? message : undefined;
};

export default extractUploadErrorMessage;
